<cookie-law name="AntiTheftCookieLaw" expiration="30">
  <label
    >Ce site Web utilise UNIQUEMENT des témoins pour assurer son fonctionnement, 
    AUCUN témoin de suivi multisite ou de ciblage publicitaire. En utilisant les 
    sites Web saferec.org, vous consentez aux pratiques décrites dans notre 
    politique de confidentialité.</label
  ><br />
  <label
    >This website ONLY uses cookies to ensure its functionality, NO cookies 
    for cross-site tracking or ad targeting. By using saferec.org websites, 
    you consent to the practices described in our Privacy Policy.</label
  ><br />
  <label
    >Este sitio web SÓLO utiliza cookies para garantizar su funcionalidad, 
    NO cookies para seguimiento entre sitios ni orientación de anuncios. Al 
    utilizar los sitios web de saferec.org, usted acepta las prácticas descritas 
    en nuestra Política de privacidad.</label
  ><br />
</cookie-law>
<router-outlet><app-spinner></app-spinner></router-outlet>
